import { Guest } from '../components/GuestCard'
export const guests: Guest[] = [
  {
    name: 'Ivan Acuna',
    title: 'Host @ Deal Flow Show',
    linkedinUrl: 'https://www.linkedin.com/in/ivan-acuna-841827198/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/86fRqntqCEt2nmFBySnXhn/headshot.png',
  },
  {
    name: 'Elliot Martinez',
    title: 'Founder/CEO @ 12 Equity',
    linkedinUrl: 'https://www.linkedin.com/in/elliot-martinez-4b93711b7/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/kn1vvqSAx6SqHomkM6t3mH/pasted-image.jpg',
    episodeUrl: 'https://www.youtube.com/watch?v=WudVFRQScqA',
  },
  {
    name: 'Ed Kobel',
    title: 'President @ DeBartolo Development',
    linkedinUrl: 'https://www.linkedin.com/in/ed-kobel-ab856ab/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/pVXCBubg3rf9Yg5kvZB75S/pasted-image.jpg',
  },
  {
    name: 'Ben Kelly',
    title: 'Partner @ LH Capital',
    linkedinUrl: 'https://www.linkedin.com/in/benjaminpkelly/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/i3DS6oQd1saEHR2K7paKrA/pasted-image.jpg',
  },
  {
    name: 'Carey Ransom',
    title: 'Managing Director @ BankTech Ventures',
    linkedinUrl: 'https://www.linkedin.com/in/careyransom',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/nrJymYzXkNhvGJB29h9BdP/pasted-image.jpg',
  },
  {
    name: 'Edoardo Maggini',
    title: 'MP @ Star Step Capital',
    linkedinUrl: 'https://www.linkedin.com/in/edoardomaggini/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/v5x7Jsa78ZFtZSyDdWqY4W/Screenshot_2025-04-06_at_2.23.49_AM.png',
    episodeUrl: 'https://www.youtube.com/watch?v=IyXurQo_hQs',
  },
  {
    name: 'Kevin Ramsier',
    title: 'Founder & MP @ Sier Capital',
    linkedinUrl: 'https://www.linkedin.com/in/askramsier/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/5nQdwJsX9YffzcMkc8uycH/pasted-image.jpg',
  },
  {
    name: 'David Mandel',
    title: 'MP @ Emerging Ventures Capital',
    linkedinUrl: 'https://www.linkedin.com/in/david-mandel-/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/v4RttpFuWWBf6qMCzPXwm8/pasted-image.jpg',
  },
  {
    name: 'Herbert Drayton III',
    title: 'Founder & GP @ HI Mark Capital',
    linkedinUrl: 'https://www.linkedin.com/in/herbertldraytoniii/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/s8EKHmmdLLab6FynYDQna2/pasted-image.jpg',
  },
  {
    name: 'KC Craichy',
    title: 'Founder/CEO @ Living Fuel, Inc.',
    linkedinUrl: 'https://www.linkedin.com/in/kc-craichy-17b54b27/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/vy85hDdVrTE9psa64WaitX/pasted-image.jpg',
  },
  {
    name: 'Peter Peterson',
    title: 'CEO @ Aspen Capital Partners',
    linkedinUrl: 'https://www.linkedin.com/in/peter-peterson-93a7b83/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/ffxYxZyNCDSjPig12NmkLE/pasted-image.jpg',
  },
  {
    name: 'Richard Wilson',
    title: 'Founder @ FamilyOffices.com',
    linkedinUrl: 'https://www.linkedin.com/in/singlefamilyoffice/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/88JSpaDX8xvuDnjwWovrag/pasted-image.jpg',
  },
  {
    name: 'Adam Coffey',
    title: 'Founding Partner @ The Chairman Group',
    linkedinUrl: 'https://www.linkedin.com/in/adamcoffey/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/5t7LQFv67PZQEh2jH3uxi8/adam_coffey.jpg',
  },
  {
    name: 'Peter Kubasek',
    title: 'Founding Partner @ Ark Malibu',
    linkedinUrl: 'https://www.linkedin.com/in/peterkubasek/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9Ap8byvEXTxK8Pex89aX5X/peter_kubasek.jpg',
  },
  {
    name: 'Gautam Basu',
    title: 'Managing Partner @ True North Search',
    linkedinUrl: 'https://www.linkedin.com/in/gautambasu/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/uoLXwBRwScie8dPZwfwQ8e/gautam_basu.jpg',
  },
  {
    name: 'Jay Patel',
    title: 'Managing Partner @ JMS Family Office',
    linkedinUrl: 'https://www.linkedin.com/in/jaypatel/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9MN5a5K2qKvExGDCknWdSG/jay_patel.png',
  },
  {
    name: 'Travis Jamison',
    title: 'Co-Founder @ Capital Pad',
    linkedinUrl: 'https://www.linkedin.com/in/travisjamison/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/6LgCFncTpq5L7nxaWdv9TU/travis_jamison.jpg',
  },
  {
    name: 'Andrew Melendez',
    title: 'Partner @ Now Capital Partners',
    linkedinUrl: 'https://www.linkedin.com/in/andrewmelendez/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/bB1jg52RGzmwEwcGCDdAFo/andrew_melendrez.jpg',
  },
  {
    name: 'Kurt Winter',
    title: 'Managing Partner @ Big 7 Ventures',
    linkedinUrl: 'https://www.linkedin.com/in/kurtwinter/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/4j1oRrwE4RYZFFLMnWnhYZ/kurt_winter.jpg',
  },
  {
    name: 'Kevin Salquist',
    title: 'Partner @ Big 7 Ventured',
    linkedinUrl: 'https://www.linkedin.com/in/kevinsalquist/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/uTkgBHe9jGSLKDmJtJ3e4F/kevin_salquist.jpg',
  },
  {
    name: 'LaDale Buggs',
    title: 'Guest @ Deal Flow Show',
    linkedinUrl: 'https://www.linkedin.com/in/ladalebuggs/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/f6FgawZA4CCJCkCHw7m9Km/ladale_buggs.jpg',
  },
  {
    name: 'Seth Deutsch',
    title: 'Founder @ Samson Partners Group',
    linkedinUrl: 'https://www.linkedin.com/in/sethdeutsch/',
    imageUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/e87tjWnBBTKZ9ryhALFdKK/Seth-Deutsch.jpg',
  },
]
